<template>
  <div class="increase-index" style="width: 100%;height: 100%;">
    <scroll-view class="increase-index" :scroll="true">
      <div class="increase-flex-text"></div>
      <!-- style="margin-bottom: 3rem;" -->
      <div class="increase-flex-input" v-if="album_id != 0">
        <div>目录名称</div>
        <input placeholder="请输入目录名称" v-model="model_name" />
      </div>
      <div class="increase-flex-input" style="margin-bottom: 3rem;" v-if="album_id != 0">
        <div>副标题</div>
        <input placeholder="请输入副标题" v-model="model_title" />
      </div>

      <div class="increase-flex-input" v-if="album_id != 0">
        <div>是否推荐</div>
        <van-radio-group v-model="radio_recommend">
          <van-radio name="1" style="margin-right: 2rem;">否</van-radio>
          <van-radio name="2">是</van-radio>
        </van-radio-group>
      </div>
      <div class="increase-flex-input" style="margin-bottom: 3rem;">
        <div>是否隐藏</div>
        <van-radio-group v-model="radio_show">
          <van-radio name="1" style="margin-right: 2rem;">否</van-radio>
          <van-radio name="2">是</van-radio>
        </van-radio-group>
      </div>

      <div class="increase-flex-input" v-if="album_id != 0">
        <div>目录图标</div>
        <div class="increase-flex-flex-button">
          <div v-if="file != null" style="background-color: #ff0000;" @click="imgDel()">删除图片</div>
          <van-uploader :after-read="afterRead" v-else>
            选择图片
          </van-uploader>
        </div>
      </div>

      <img :src="file.ali_url" class="increase-flex-img" v-if="file != null && album_id != 0" />
    </scroll-view>
    <div class=".increase-flex-button" style="position: initial;opacity: 0;margin-bottom: 3%;">提交</div>
    <div class="increase-flex-button" @click="goBack()">提交</div>
  </div>
</template>

<script>
  import {
    RadioGroup,
    Radio,
    Uploader,
    Button
  } from 'vant';
  import {
    Adminalbumpicupload,
    Adminalbumdirectoryedit,
    Adminalbumdigetinfo
  } from '@/request/api.js';
  export default {
    components: {
      [Uploader.name]: Uploader,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Button.name]: Button
    },
    data() {
      return {
        radio_recommend: '1',
        radio_show: '1',
        file: null,
        directory_id: 0,
        model_name: '',
        model_title: '',
        album_id: 0
      }
    },
    created() {
      let param = this.$api.parseUrl();
      if (param) {
        this.album_id = param.album_id;
        this.directory_id = param.directory_id;
        document.title = '编辑目录';
      } else {
        this.$api.Message('提示', '参数出错，请重新进入').then((res) => {
          console.log(res)
        })
      }
      this.list_load();
      typeof WeixinJSBridge != 'undefined' && WeixinJSBridge.call('hideOptionMenu');
    },
    methods: {
      async list_load() {
        let res = await Adminalbumdigetinfo({
          directory_id: this.directory_id
        });
        this.file = {ali_url:res.data.image_text,url:res.data.image};
        this.radio_recommend = res.data.is_recom_switch == 0 ? '1' : '2';
        this.radio_show = res.data.is_hide_switch == 0 ? '1' : '2'
        this.model_name = res.data.name;
        this.model_title = res.data.title;
      },
      async goBack() {
        let param = this.album_id != 0 ? {
          name: this.model_name,
          title: this.model_title,
          is_recom_switch: this.radio_recommend == '1' ? 0 : 1,
          is_hide_switch: this.radio_show == '1' ? 0 : 1,
          image: this.file != null ? this.file.url : '',
          directory_id: this.directory_id,
          album_id:this.$store.state.userInfo.album_id,
		  operate_album_id:this.$store.state.userInfo.album_id
        } : {
          is_hide_switch: this.radio_show == '1' ? 0 : 1,
          directory_id: this.directory_id,
          album_id:this.$store.state.userInfo.album_id,
		  operate_album_id:this.$store.state.userInfo.album_id
        }
        console.log(param)
        let res = await Adminalbumdirectoryedit(param);
        history.go(-1);
      },
      async afterRead(event) {
        let param = new FormData();
        param.append('file', event.file, event.file.name);
        let res = await Adminalbumpicupload(param);
        this.file = res.code;
      },
      imgDel() {
        this.file = null;
      }
    }
  }
</script>

<style lang="less">
  .increase-index {
    font-size: 1.2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;

    .increase-flex-input {
      width: 94%;
      background-color: #FFFFFF;
      margin-left: 3%;
      border: 1px solid #F4F4F4;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: -1px;
    }

    .increase-flex-input>div:nth-child(1) {
      padding: 1rem 0;
      width: 25%;
      background-color: #F4F4F4;
      text-align: center;
    }

    .increase-flex-input>input:nth-child(2) {
      flex: 1;
      margin-left: 1rem;
    }

    .increase-flex-text {
      width: 100%;
      margin-bottom: 3rem;
    }

    .increase-flex-button {
      width: 90%;
      background-color: #2590c8;
      color: #FFFFFF;
      padding: 1rem 2%;
      text-align: center;
      position: fixed;
      bottom: 3%;
    }

    .van-radio-group {
      flex: 1;
      display: flex;
      flex-wrap: nowrap;
      margin-left: 1rem;
    }

    .increase-flex-flex-button {
      flex: 1;
      display: flex;
      flex-wrap: nowrap;
    }

    .increase-flex-flex-button>div {
      width: 100%;
      background-color: #009688;
      color: #FFFFFF;
      padding: 1rem 2%;
      text-align: center;
    }

    .increase-flex-img {
      width: 30%;
      margin-left: 3%;
      margin-bottom: 3rem;
      margin-top: 1rem;
    }

    .van-uploader__wrapper {
      justify-content: center;
    }
  }
</style>
